<style scoped>
ol.margin-ol > li {
    @apply ml-10;
}

ol.lower-alpha {
    list-style-type: lower-alpha;
}
</style>

<template>
    <contentBlock>
        <h1>常見問題</h1>
        <h2>帳戶資料及一般查詢</h2>
        <collapsible class="mb-4" title="如何登記帳戶？">
            您可以透過我們向
            貴公司發出的邀請電郵，進入本網站的登記頁面，並輸入您的公司電郵地址，填寫用戶資料和登入密碼之後，您便可以在本網站盡情購物。
            <br />

            您將會收到一封確認電郵，請點擊電郵內的連結以確認電郵地址正確無誤。
            <br />

            如果您尚未收到我們的邀請電郵，請向 貴公司人事部查詢。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="我可以使用個人電郵地址登記帳戶嗎？">
            根據各公司的設定，我們或只接受以 貴公司電郵域名(email
            domain)的電郵地址登記帳戶。如果您並沒有公司電郵地址，而本網站並不接受個人電郵地址登記帳，請向
            貴公司人事部查詢。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何更改我的個人資料和密碼？">
            請以您的帳戶登入，然後點擊您的名字，進入「帳戶資料」，更新您的個人資料。完成後按「更改」。
            <br />

            如果您想更改密碼，請在「帳戶資料」點擊「更改密碼」，輸入現有密碼及新密碼。完成後按「儲存」。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如果我忘記密碼，可以怎麼做？">
            請在登入主頁按「忘記密碼？」，輸入您的帳戶電郵地址。
            <br />

            您將會收到一封重設密碼電郵，請點擊電郵內的連結進入本網站，重新設置密碼。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="為何我接收不到系統發出的電郵？">
            您可嘗試於垃圾收件匣尋找。如無此電郵，請<a
                href="#contact"
                @click="$refs.contactUs.toggle(true)"
                >與我們聯絡</a
            >。
            <br />
        </collapsible>
        <a id="contact"></a>
        <collapsible class="mb-4" title="如何成為「試吓啦」的供應商？">
            請電郵至
            <a href="mailto:enquiry@tryhala.com">enquiry@tryhala.com </a>
            與我們聯絡。詳情請參閱
            <a href="https://tryhala.com" target="_blank">
                https://tryhala.com
            </a>
            。
            <br />
        </collapsible>
        <collapsible
            class="mb-4"
            title="我如何查詢及提供意見？"
            ref="contactUs"
        >
            您可以在
            <router-link tag="a" to="contactUs">
                這裏
            </router-link>
            查詢及提供意見。我們將會透過電郵或電話與您聯絡。
            您亦可致電客戶服務熱線 2784
            2838，我們的服務時間為星期一至五上午9時至下午6時(公眾假期除外)。或透過電郵到
            <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
            查詢及提供意見。
            <br />
        </collapsible>

        <h2>T-coin</h2>
        <collapsible class="mb-4" title="甚麼是「T-coin」?">
            在本網站購物時，您可以使用「T-coin」代替付款。每5「T-coin」可作HK$1使用。本網站或不時提供各種優惠，敬請留意。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何獲得「T-coin」?">
            於單一訂單購物每滿HK$20（扣減所有折扣後計算），即可獲得1「T-coin」。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="「T-coin」有使用期限嗎?">
            目前「T-coin」沒有使用期限。
            <br />
        </collapsible>

        <h2>訂購產品</h2>

        <collapsible class="mb-4" title="如何訂購產品？">
            透過以下簡單步驟，就可以在「試吓啦」輕鬆享受購物樂趣。
            <br />
            <ol>
                <li>登入帳戶。</li>
                <li>把心水產品加入購物車。</li>
                <li>
                    在購物車查看或編輯您的貨品及數量，選擇取貨地點及付款方式，然後按「確認訂單」。
                </li>
                <li>
                    視乎您的訂單是否需要付款:
                    <ol class="margin-ol lower-alpha">
                        <li>
                            如果您的訂單不需要付款，請按「確認訂單」完成訂購；
                        </li>
                        <li>
                            如果您的訂單需要付款，請選擇您的付款方式，確認訂單後請按網頁指示輸入付款資料。
                        </li>
                    </ol>
                </li>
                <li>
                    確認訂單及 /或 完成付款後，您將會收到系統發出的確認電郵。
                </li>
            </ol>
        </collapsible>
        <collapsible class="mb-4" title="如何把產品加入購物車？">
            在產品主頁，您可以點擊產品圖片下方的「加入購物車」連結，把一件產品直接加入購物車。
            <br />

            另外，您也可以在產品資料頁，選擇欲訂購數量，然後點擊「加入購物車」。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何付款？">
            目前，我們接受多種的付款方式，如︰現金、VISA、萬事達卡、支付寶（香港）和微信支付（香港）。不同公司可使用的付款方式不同，詳情請以實際付款頁面為準。
            <br />
            如您選擇了以現金支付訂單，在截單日期過後，
            貴公司各取貨地點的負責人將會協助收集款項，於送貨時一併繳付。
            <br />
            我們會不時更新付款方法，為您提供更方便快捷的購物體驗，敬請留意。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何使用優惠券？">
            如果您有可使用的優惠券，即可在購物車點選「使用優惠券」，然後選擇優惠券。購物車將會即時顯示扣減及餘額。然後按「確認訂單」完成訂購過程。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何使用「T-coin」？">
            當您在購物車確認訂單時，即可點選「使用T-coin」，然後輸入使用的數量。購物車將會即時顯示扣減及餘額。然後按「確認訂單」完成訂購過程。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何查看訂單記錄？">
            請以您的帳戶登入，然後點擊您的名字，選擇「訂單記錄」，查看最近的交易記錄，包括訂單日期，交易總計及訂單狀態。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何設定或更改取貨地點？">
            請以您的帳戶登入，然後點擊您的名字，進入「帳戶資料」，設定或更改您的取貨地點。完成後按「更改」。
            <br />

            請在確認訂單前，檢查及確定取貨地點。訂單確認後，不能更改取貨地點，敬請留意。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="為甚麼我不能訂購所選的產品/產品數量？">
            產品供應數量有限，可能未必達到您想訂購的數量。另外，某些產品可能設限每位顧客最多可購買的件數，敬請留意。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="我可以重複訂購產品嗎？">
            您可以在同一個售貨期內，提交多張訂單。但請留意，某些產品可能設限每位顧客最多可購買的件數，這個限額是適用於整個售貨期的。
            <br />
        </collapsible>
        <collapsible
            class="mb-4"
            title="為甚麼我已經登入產品主頁，但看不到產品？"
        >
            當一個售貨期截單過後，產品將會暫時下架以準備下一期的產品。待準備完成後，您將會收到最新一期產品的邀請電郵，敬請密切留意。
            <br />
        </collapsible>

        <h2>送貨、退換貨及退款</h2>

        <collapsible class="mb-4" title="如何查看送貨時間及地點？">
            您可以在「訂單記錄」裏查看預計送貨日期及地點。請以您的帳戶登入，然後點擊您的名字，選擇「訂單記錄」，在訂單列表點擊訂單查詢。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="如何知道貨品已經送出？">
            我們將會在售貨期截單後，陸續為
            貴公司各取貨地點送貨。在送貨時，我們會與各取貨地點的負責人聯絡。請向相關取貨地點的負責人查詢。
            <br />
        </collapsible>
        <collapsible class="mb-4" title="我可以更改取消訂單嗎？">
            很抱歉，已確認的訂單交易恕不能更改或取消。如果您於確認訂單後發現資料有誤，請盡快<a
                href="#contact"
                @click="$refs.contactUs.toggle(true)"
                >與我們聯絡</a
            >。
            <br />
        </collapsible>
        <collapsible
            class="mb-4"
            title="如果我收不到齊全的貨品，或收到不正確/損壞的貨品，可以怎麼做？"
        >
            請<a href="#contact" @click="$refs.contactUs.toggle(true)"
                >與我們聯絡</a
            >，並按要求提供訂單編號，產品資料及其他相關資料。
            <br />

            如有爭議，「試吓啦」保留最終之決定權。
            <br />
        </collapsible>
        <p>
            <br /><br />
            最近更新日期：2020年12月
        </p>
    </contentBlock>
</template>

<script>
import collapsible from '@/components/collapsible.vue';
import contentBlock from '@/components/contentBlock.vue';

export default {
    components: {
        collapsible,
        contentBlock
    }
};
</script>
